import {
  ElementoLogisticoPosicion,
  EnumEstadoOperacionConciliar,
  EnumOperationState,
  EnumPrecioUnitario,
  EnumSubTipoElemLog,
  EnumTipoOperacion,
  EnumTipoPosicion,
  EnumUnidadMedida,
  EnumZonaBalance
} from '../..'
import { PriceVersion } from '../../../pages/pricing/pricing.Model'
import { EnumCommodity, EnumPriceCalculationType, EnumRedondeo } from '../../Argentia/enums'
import { EnumPriceType } from '../../oData/enums/enumPriceType'
import { EnumTipoMetodoPago } from '../../oData/enums/enumTipoMetodoPago'
import { EnumTipoValidacion } from '../../oData/enums/enumTipoValidacion'
import { PositionType, ValidationType } from '../enums'
import { Commodities } from '../enums/commodities'
import { EnumNivelCicloFacturacion } from '../enums/nivelCicloFacturacion'
import { UnitMeasure } from '../enums/unitMeasure'
import { Capacity } from './Capacity'

export interface AddComplexTradeRequest {
  code?: string
  description: string
  currency: EnumCurrency
  initDate: Date
  endDate: Date
  signDate: Date
  state: ValidationType
  company: number
  counterpart: number
  book?: number
  category?: number
  comments?: string
  commodity?: Commodities
  contract?: number
  billingLevel?: number
  billingCycle?: number | null
  paymentMethod?: EnumTipoMetodoPago
  brokers?: Broker[]
  positions?: PositionPrice[]
  balanceZone?: number
  broker?: number
  commission?: number
  expression?: string
  conceptId?: number
  currencyAndUnit?: EnumPrecioUnitario
  priceCalculationType?: EnumPriceCalculationType
  rounding?: EnumRedondeo
  priceType?: EnumPriceType
}
export interface AddTradeRequest {
  code?: string
  description: string
  counterpart: number
  balanceZone: number
  deliveryPoint: number
  type: PositionType
  currency: EnumCurrency
  initDate: Date
  endDate: Date
  signDate: Date
  state: ValidationType
  dailyQuantity: number
  dailyQuantityUnit: UnitMeasure
  totalQuantity?: number
  fee: number
  commodity?: Commodities
  brokers?: Broker[]
  category?: number
  book?: number
  contract?: number
  paymentMethod?: EnumTipoMetodoPago
  billingLevel?: number
  billingCycle?: number | null
  broker?: number
  commission?: number
  comments?: string
  company: number
  expression?: string
  conceptId?: number
  currencyAndUnit?: EnumPrecioUnitario
  priceCalculationType?: EnumPriceCalculationType
  rounding?: EnumRedondeo
  priceType?: EnumPriceType
  positions?: PositionPrice[]
}

export interface AddTradeAPIRequest {
  code?: string
  description: string
  counterpart: number
  currency: EnumCurrency
  initDate: string
  endDate: string
  signDate: string
  state: ValidationType
  commodity: number
  company: number
  category?: number
  book?: number
  contract?: number
  paymentMethod?: EnumTipoMetodoPago
  billingLevel?: number
  billingCycle?: number | null
  commission?: number
  comments?: string
  brokers?: Broker[] | null
  positions?: PositionPriceAPIRequest[]
}

export interface GeneratePositionCodeAPIRequest {
  positionType: number | string
}

export interface GeneratePositionCodeAPIResponse {
  code: string
}

export interface PatchTradePioneerRequest {
  trade?: Partial<TradeModelPatchPioneerRequest>
  delete?: Partial<TradeDeleteRefRequest>
}

export interface TradeModelPatchPioneerRequest extends Omit<
  TradeDetailsRequest,
  'fechaInicio' | 'fechaFin' | 'fechaFirma' | 'posicionesDelta'
> {
  fechaInicio: string
  fechaFin: string
  fechaFirma: string
  posicionesDelta: PosicionModelPatchPioneerRequest[]
}

export interface PosicionModelPatchPioneerRequest extends Omit<
  Partial<PosicionDelta>,
  'fechaInicio' | 'fechaFin' | 'tramosDelta'
> {
  fechaInicio?: string
  fechaFin?: string
  tramosDelta?: TramosModelPatchPioneerRequest[]
}

export interface TramosModelPatchPioneerRequest extends Omit<
  Partial<Tramo>,
  'fechaInicio' | 'fechaFin'
> {
  fechaInicio?: string
  fechaFin?: string
}

export interface CheckTradeSimpleResponse {
  tradeId: number
  isSimple: boolean
}

export interface PriceConceptRequest {
  priceUnit: EnumPrecioUnitario
  rounding: EnumRedondeo
  priceCalculationType: EnumPriceCalculationType
  expression: string
  startDate?: string
  endDate?: string
}

export interface CreatePriceForPositionRequest {
  tradeID: number
  positionID: number
  price: PriceConceptRequest
}

export interface CreatePriceForPositionResponse {
  id: number
  idConcepto: number
  idProducto: number | null
  idContrato: number | null
  price: PriceVersion
}

// Rulebook Region
export interface RulebookResponse {
  success: boolean
  errors: RulebookError
}

export interface RulebookError {
  code: number
  message: string
}

export interface CheckCounterpartTradeRulebookRequest {
  tradeId: number
  counterpartId: number
}

export interface CheckLogisticElementRulebookRequest {
  tradeId: number
  positionId: number
  deliveryPoint: number
  oldDeliveryPoint: number
}

export interface CheckQuantityRulebookRequest {
  positionId: number
  counterpart: number
  startDate: string
  endDate?: string
  quantity: number
  oldQuantity?: number
}

export interface CheckPositionTypeRulebookRequest {
  tradeId: number
  positionId: number
  counterpart: number
}

export interface CheckStartDateTradeRulebookRequest {
  tradeId: number
  startDate: Date
  oldDate: Date
  counterpartId: number
}

export interface CheckEndDateTradeRulebookRequest {
  tradeId: number
  endDate: Date | null
  oldDate: Date | null
  counterpartId: number
}

export interface CheckEndDatePositionRulebookRequest {
  tradeId: number
  positionId: number
  positionEndDate: string
  tradeStartDate: string
  tradeEndDate: string
  counterpartId: number
}

export interface CheckStartDateTractRulebookRequest {
  tradeId: number
  positionId: number
  tractStartDate: string
  tractEndDate?: string | null
  oldTractStartDate: string | null
  positionStartDate?: string
  positionEndDate?: string
  counterpart?: number
}

export interface CheckEndDateTractRulebookRequest {
  tradeId: number
  positionId: number
  tractStartDate?: string
  tractEndDate: string
  oldTractEndDate?: string | null
  positionStartDate?: string
  positionEndDate?: string
  counterpart?: number
}

export interface CheckPresentFutureDatesRulebookRequest {
  tradeId: number
  positionId: number
  counterpart: number
  tracts: CheckPresentFutureDatesTractRequest[]
}

export interface CheckPresentFutureDatesTractRequest {
  startDate: string
  endDate: string
  dailyQuantity: number
}

export interface CheckDeletePositionRulebookRequest {
  positionId: number
  counterpart?: number
}

export interface CheckDeleteTractRulebookRequest {
  positionId: number
  tradeId: number
  tractStartDate: string
  tractEndDate: string
  counterpart?: number
  company: number
}

export interface CheckDateTimeLessThanRulebookRequest {
  date: string
}

export interface CheckPastTradeRulebookRequest {
  counterpartId: number
}

export interface ValidateTradeRulebookRequest {
  trade: ValidateTradeRulebookModel
  oldCounterpartId?: number
}

export interface PositionsDates {
  initDate: string
  endDate: string
}

export interface ValidateTradeRulebookModel {
  tradeId: number
  counterpartId: number
  initDate: string
  endDate: string
  signDate: string
  positions?: PositionsDates[]
}

export interface ValidatePositionRulebookRequest {
  position: ValidatePositionRulebookModel
  tradeStartDate: string
  tradeEndDate: string
  counterpartId: number
  deletePosition?: boolean
  oldDeliveryPoint?: number
  oldPositionType?: number
}

export interface ValidatePositionRulebookModel {
  positionId: number
  tradeId: number
  startDatePosition: string
  endDatePosition: string
  deliveryPointId?: number | null
  positionType: number
  tracts: CheckPresentFutureDatesTractRequest[]
}

export interface ValidateTractRulebookRequest {
  tradeId?: number
  positionId?: number
  tractId?: number
  positionStartDate?: string
  positionEndDate?: string
  tract: ValidateTractRulebookModel
}

export interface ValidateTractRulebookModel {
  startDate: string
  endDate: string
  quantity: number
}

export enum EnumStartDateRulebookError {
  tradeStartDate = 1,
  tractStartDate
}

export enum EnumEndDateRulebookError {
  tradeEndDate = 1,
  tractEndDate
}

export interface TradeDetailsPioneerRequest {
  id: number
  codTrade: string
  descripcion: string
  divisa: Divisa
  tradeType: TradeType
  fechaInicio: Date
  fechaFin: Date
  fechaFirma: Date
  validacion: EnumTipoValidacion
  comentarios: string
  posicionesDelta: Partial<PosicionDelta>[]

  contratoId: number
  conceptoId: number
  precioConceptoId: number

  contraparteId: number
  metodoPagoId: number
  cicloFacturacionId: number
  brokerIds: number[]
}

export interface TradeDetailsRequest {
  id: number
  descripcion: string
  contraparte: number
  divisa: Divisa
  tradeType: TradeType
  fechaInicio: Date
  fechaFin: Date
  fechaFirma: Date
  validacion: EnumTipoValidacion
  comentarios: string
  contratoId: number
  nivelFacturacion: EnumNivelCicloFacturacion | string | null
  cicloFacturacionId: number | null
  metodoPagoId: number | null
  conceptoId: number
  precioConceptoId: number
  posicionesDelta: Partial<PosicionDelta>[]
  brokers: any[]
}

export interface TradeDetailsPatchRequest extends Omit<Partial<TradeDetailsRequest>, 'id'> {
  id?: number
}

export interface TradeDeleteRefRequest {
  brokersId: number[]
}

export interface comercialRequest {
  commercialId?: number // if it's an update of an existing Broker.
  counterpartId?: number // only necessary if it's a new Broker.
  commercialSubjectId: number // Broker's subject.
  productId: number // commission
}

export interface PosicionDelta {
  id: number | string // "Posiciones(1)"
  descripcion: string
  codPosicion: string
  tipoPosicion: EnumTipoPosicion | string
  unidadMedida: EnumUnidadMedida | string
  cantidadTotal: number
  fechaInicio: Date
  fechaFin: Date
  puntoEntregaDelta: Partial<PuntoEntregaDelta>
  tramosDelta: Partial<Tramo>[]
  price: Partial<PricePosition> | Partial<PrecioPosicionRequest>
  zonaBalance: EnumZonaBalance | string | number
  removed?: DeltaRemoved
}

export interface DeltaRemoved {
  reason: string
}
export interface TramosDelta {
  id: string // "Tramos(1)"
  fechaInicio: Date
  fechaFin: Date
  fee: number
  cantidadDiaria: number
  removed?: DeltaRemoved
}

export interface PrecioDelta {
  id: number
  priceCalculationType: EnumPriceCalculationType
  expression: string
  precioUnitario: EnumPrecioUnitario
  redondeo: EnumRedondeo
}

export interface PuntoEntregaDelta {
  id?: number | string // "elementoslogisticos(2)"
}
export interface FetchRequest {
  initDate?: Date
  endDate?: Date
  company: number
  balanceZone?: EnumZonaBalance
  counterpart?: number
  deliveryPoint?: number
  version?: number
  subjectType?: number
}

export interface FetchAPIRequest {
  initDate?: string
  endDate?: string
  company: number
  balanceZone?: EnumZonaBalance
  counterpart?: number
  deliveryPoint?: number
  version?: number
}

export interface TradeListItem {
  id: number
  signDate: Date
  codTrade: string
  description?: string
  positionType?: string
  multiposition: boolean
  deliveryPoints?: LogisticElementBase[]
  deliveryPointsIds?: number[]
  initDate: Date
  endDate: Date
  validation: ValidationType
  counterpart?: string
  commodity?: EnumCommodity
}

export interface TradeDetailsResponse {
  tradeId: number
  code: string
  description: string
  type: number
  currency: number
  initDate: Date
  endDate: Date
  signDate?: Date
  state: number
  company: number

  counterpartId?: number
  counterpartDescription?: string
  categoryId?: number
  categoryDesc?: string
  book?: number
  contractId?: number
  contractCode?: string
  paymentMethodType?: string
  billingLevel?: string
  billingCycle?: string
  billingCycleId?: number
  broker?: number
  commission?: number
  comments: string

  expression: string
  priceCalculationType?: EnumPriceCalculationType
  currencyAndUnit?: EnumPrecioUnitario
  rounding: EnumRedondeo
  priceType?: EnumPriceType
  conceptId?: number
  commodity?: EnumCommodity

  priceId?: number
  conceptPriceId?: number

  brokers: Broker[]
  positions: PosicionPrecio[]
  paymentMethods?: PaymentMethod
}

export interface TradeResponse extends AddTradeRequest {
  id: number
}

export interface TradeMainDetails {
  id?: number
  code: string
  description: string
  counterpart?: number
  counterPartDescription?: string
  deliveryPointDescription?: string
  deliveryPoint?: number
  currency?: number
  initDate: Date
  endDate: Date
  signDate?: Date
  state?: ValidationType

  commodity?: Commodities

  // Position props
  positionId?: number
  positionCode: string
  type?: PositionType
  balanceZone?: number

  dailyQuantityUnit?: EnumUnidadMedida
  totalQuantity?: number

  // Tract props
  tractId?: number
  dailyQuantity?: number
  fee?: number
}

export type PositionMainDetails = Omit<
  TradeMainDetails,
  | 'id'
  | 'code'
  | 'description'
  | 'counterpart'
  | 'counterPartDescription'
  | 'deliveryPointDescription'
  | 'currency'
  | 'signDate'
  | 'state'
  | 'commodity'
  | 'positionCode'
>

export interface TradeAditionalsDetails {
  category?: number | null
  book?: number | null
  contract?: number | null
  paymentMethod?: EnumTipoMetodoPago | PaymentMethod | null
  billingLevel?: EnumNivelCicloFacturacion | null
  billingCycleId?: number | null
  brokers?: Broker[] | null
  // Temporalmente hasta que se defina cómo mostrar la lista de pares Broker-Comisión, se mostrará únicamente el primero de la lista.
  broker?: Broker | null

  comments?: string | null
}

export interface TradePricingDetails {
  id?: number
  company?: number
  expression?: string
  conceptId?: number
  priceConceptId?: number
  currencyAndUnit?: EnumPrecioUnitario
  priceCalculationType?: EnumPriceCalculationType
  rounding?: EnumRedondeo
  priceType?: EnumPriceType
  version?: number
  startDate?: Date
  endDate?: Date
}

export interface TradePriceRequest {
  id?: number
  expression?: string
  precioUnitario?: number
  priceCalculationType?: number
  redondeo?: number
  priceType?: number
  version?: number
}

export interface BillingCycle {
  idBillingCycle: number
  description: string
  launchDate: Date
  periodicityType: EnumPeriodicityType
  cycleBillingType: EnumCycleBillingType
  generateInvoice: boolean
  automatic: boolean
  validateList: boolean
  manualReview: boolean
  distribution: boolean
  operationType: EnumOperationType
  billingType: EnumBillingType
  subjectType: EnumSubjectType
}

export interface LogisticElementBase {
  id: number
  description: string
  elementLogisticType?: EnumElemLogType | null
  elementLogisticSubType?: EnumSubTipoElemLog | null
  associatedSubtypes?: EnumSubTipoElemLog[] | null
  codElementoLogistico?: string | null
  codAcer?: string | null
  balanceZone: EnumZonaBalance
}

export interface Commercial {
  idComercial: number
  sujetoComercial: Subject
  contrato: Contract
}

export interface Broker {
  commercialId?: number | null
  subjectId?: number | null
  //subjectDescription?: string;
  commissionId?: number | null
  //productCode?: string;
}

export interface LogisticElement extends LogisticElementBase {
  infrastructureList: LogisticElementBase[]
  supraPointsList: LogisticElementBase[]
  positionsList: LogisticElementBase[]
  pointsList: LogisticElementBase[]
}
export interface TradeTypeBase {
  id: number
  description: string
}

export interface LogisticElement extends LogisticElementBase {}

export interface PositionPrice {
  id?: number
  code?: string
  description?: string
  positionType: EnumTipoPosicion
  measureUnit: EnumUnidadMedida
  balanceZone: EnumZonaBalance
  totalQuantity?: number
  conceptPriceId?: number
  conceptId?: number
  price?: Partial<PricePosition>
  deliveryPointId: number
  deliveryPoint?: LogisticElement
  idPuntoEntrega?: number
  startDate: Date
  endDate: Date
  tracts: Partial<Tract>[]
}

export interface PositionPriceAPIRequest extends Omit<
  PositionPrice,
  'startDate' | 'endDate' | 'tracts'
> {
  startDate: string
  endDate: string
  tracts: TractAPIRequest[]
}

export interface TractAPIRequest extends Omit<Partial<Tract>, 'startDate' | 'endDate'> {
  startDate: string
  endDate: string
}

export interface PosicionPrecio {
  deliveryPoint: LogisticElement
  idPosicion: number
  codPosicion: string
  descripcion: string
  tipoPosicion: EnumTipoPosicion | string
  unidadMedida: EnumUnidadMedida | string
  zonaBalance?: EnumZonaBalance
  cantidadTotal?: number
  price?: Partial<PricePosition>
  idPuntoEntrega?: number
  puntoEntrega: Partial<ElementoLogisticoPosicion>
  fechaInicio: Date
  fechaFin: Date
  tramos: (Tramo | NewTramo)[]
  idTrade: number
  idConceptoPrecio?: number
  idConcepto?: number
  puntoEntregaId?: number
}

export interface PosicionPrecioDiff extends Omit<PosicionPrecio, 'tramos'> {
  tramos: Partial<TramosDelta>[]
}

export interface PrecioPosicionRequest {
  id: number
  priceCalculationType?: string
  expression: string
  precioUnitario?: string
  redondeo: string
  version: number
  startDate?: string
  endDate?: string
}

export interface PricePosition {
  id: number
  priceCalculationType?: EnumPriceCalculationType
  expression: string
  priceUnit?: EnumPrecioUnitario
  rounding: EnumRedondeo
  version: number
  startDate?: Date | string
  endDate?: Date | string
}

export interface NewPosicionPrecio extends Omit<PosicionPrecio, 'idPosicion' | 'codPosicion'> {
  idPosicion?: number
  codPosicion?: string
  // Temporal hasta desarrollar el front con Posiciones con multiTramo, vamos a mapear el primer tramo como si la posicion fuera de tramo unico.
  cantidadDiaria?: number
  fee?: number
}

export interface NewPricePosition extends Omit<PricePosition, 'id'> {
  idPrice?: number
}

export interface NewPrecioPosicion {
  idPrice?: number
  priceCalculationType?: string
  expression: string
  precioUnitario?: string
  redondeo: string
  version: number
  startDate?: Date
  endDate?: Date
}

export interface NewTramo extends Omit<Tramo, 'idTramo'> {
  idTramo?: number
}

export interface Tramo {
  idTramo: number
  fechaInicio: Date
  fechaFin: Date
  cantidadDiaria?: number
  cantidadTotal?: number
  fee?: number
  idPosicion?: number
  precio?: number
}

export interface Tract {
  idTramo?: number
  startDate: Date
  endDate: Date
  dailyQuantity?: number
  fee?: number
}

export interface Subject {
  id: number
  deSubject: string
  subjectType: EnumSubjectType
  subjectSubType: EnumSubjectSubType
  codSubject: string
  name: string
  lastName1: string
  lastName2: string
  personType: EnumTaxDocumentType
  residenceType: EnumResidenceType
  nationality: EnumCountry
  documentType: EnumDocumentIdentityType
  supplyType: EnumSupplyType
  taxDocument: string
  language: EnumLanguage
  commodity: EnumCommodity
  enabled: boolean
  address: FiscalAddress
  detail: SubjectDetail[]
  subjectCode: CodeSubject[]
  contacts: Contact[]
  contracts: Contract[]
  company: Company
}

export interface Contact {
  idContactInfo: number
  contactPerson: string
  telephone: string
  email: string
  additionalInfo: string
  principal: boolean
  notificationType: EnumNotificationType
  idContract: number
}

export interface Company {
  idCompany: number
  lgMaster: boolean
  subject: Subject[]
}

export interface SubjectDetail {
  idSubjectDetail: number
  codExternal: string
  codSifco: string
  codEic: string
  startDateValidity: Date
  endDateValidity: Date
}

export interface CodeSubject {
  idCodeSubject: number
  idSubject: number
  codeType: EnumCodeType
  code: string
  balanceZone: EnumZonaBalance
  initDate: Date
  endDate: Date
}

export interface Contract {
  id: number
  codContract: string
  description: string
  contractType: EnumContractType
  initDate: Date
  endDate: Date
  signDate: Date
  offerDate: Date
  paymentMethod: PaymentMethod
  book: Book
  currency: EnumCurrency
  balanceZone: EnumZonaBalance
  state: ValidationType
  capacityDistributionList: Capacity[]
  subject: Subject
  Cups: CupsModel[]
}
export interface Contract2 {
  id?: number
  contractCode: string
  state?: ValidationType
  startDate: Date
  endDate?: Date
  signatureDate?: Date
  balanceZone?: EnumZonaBalance
  paymentMethod: PaymentMethod
  billingCycleID: number
  subjectID: number
  cupsList: CupsModel[]
  // productsList: ProductModel[],
  companyID: number
  commodity: EnumCommodity
}

export interface Book {
  idBook: number
  description: string
}

export interface Divisa {
  id?: number
}

export enum EnumContractType {
  TipoContratoInvalido = 0,
  ClienteFinal = 11,
  Trade = 14,
  Gnl = 16,
  ClienteComercial = 17,
  Financiero = 23,
  Electricidad = 1011
}

export enum EnumCurrency {
  EUR = 1,
  USD,
  GBP
}

export enum EnumNotificationType {
  Postage = 1,
  SendEmail
}

export enum EnumCodeType {
  Acer = 1,
  TSO,
  DSO,
  EIC,
  MS_ATR,
  Agent,
  CNMC
}

export enum EnumResidenceType {
  Resident = 1,
  EUResident,
  Foreign
}

export enum EnumCountry {
  ES = 1,
  DE = 4,
  AD = 6,
  BE = 18,
  FR = 71,
  GI = 76,
  IT = 122,
  NL = 172,
  PT = 182,
  GB = 185,
  CH = 218
}

export enum EnumDocumentIdentityType {
  NIF = 1,
  Passport,
  NIE,
  NIVA,
  Others
}

export enum EnumSupplyType {
  Gas = 1,
  Light,
  LightAndGas
}

export enum EnumLanguage {
  ES = 1,
  CA
}

export enum Commodity {
  NaturalGas = 1,
  Electricity
}

export enum EnumSubjectSubType {
  Domestico = 1,
  ComunidadPropietarios = 2,
  Pyme = 3,
  Administracion = 4,
  Industrial = 5,
  Broker = 6,
  Mercado = 7,
  Gasinera = 8,
  Mayorista = 9,
  DomesticoGrupo = 20,
  HotelResort = 21,
  HotelResortGrupo = 22,
  PymeGrupo = 23,
  IndustrialGrupo = 24,
  GNV_GNL = 25,
  GNV_GNC = 26,
  GNV_GNLC = 27,
  Camionero = 29,
  Licitacion = 30,
  Residencial_Comunidades = 31,
  Vehicular = 32,
  LicitacionSinCuota = 33,
  AdministracionSinCuota = 34
}

export enum EnumTaxDocumentType {
  Physical = 1,
  Legal
}

export enum EnumStatusClient {
  Draft = 1,
  Initiated,
  Accepted,
  Rejected,
  Active,
  Canceled,
  Drop
}

export interface PaymentMethod {
  typeMethodPayment: EnumTypeMethodPayment
  bankAccount: string
  iban: string
  codBankEntity: string
  bankingEntity: EnumBankingEntity
  billingAddress: FiscalAddress
}

export interface TradeType {
  id?: number
  description?: string
}

export interface FiscalAddress {
  IdAddress?: number
  Address: string
  AddressCP: string
  IdAddressMunicipality: number
  CodAddressMunicipality: string
  AddressMunicipality: string
  IdAddressProvince: number
  CodAddressProvince: string
  AddressProvince: string
  IdAddressCountry: number
  CodeAddressCountry: string
  CountryAddress: string
  RegionTaxes: EnumRegionTaxes
  OdataId: string
}

export enum EnumRegionTaxes {
  PENINSULA = 1,
  ISLAS,
  CEUTA_MELILLA
}

export enum EnumBankingEntity {
  ABANCA_CORPORACION_BANCARIA_SA = 1,
  AG_BANCA_PRIVADA_SA,
  ALLFUNDS_BANK_SA,
  ANDBANK_ESPANA_SA,
  ARESBANK_SA,
  BANCA_MARCH_SA,
  BANCA_PUEYO_SA,
  BANCO_ALCALA_SA,
  BANCO_BILBAO_VIZCAYA_ARGENTARIA_SA,
  BANCO_CAIXA_GERAL_SA,
  BANCO_CAMINOS_SA,
  BANCO_CETELEM_SA,
  BANCO_COOPERATIVO_ESPANOL_SA,
  BANCO_DE_ALBACETE_SA,
  BANCO_DE_CAJA_ESPANA_DE_INVERSIONES_SALAMANCA_Y_SORIA_SA,
  BANCO_DE_CASTILLA_LA_MANCHA_SA,
  BANCO_DE_CREDITO_SOCIAL_COOPERATIVO_SA,
  BANCO_DE_DEPOSITOS_SA,
  BANCO_DE_SABADELL_SA,
  BANCO_EUROPEO_DE_FINANZAS_SA,
  BANCO_FINANTIA_SOFINLOC_SA,
  BANCO_INDUSTRIAL_DE_BILBAO_SA,
  BANCO_INVERSIS_SA,
  BANCO_MEDIOLANUM_SA,
  BANCO_OCCIDENTAL_SA,
  BANCO_PASTOR_SA,
  BANCO_PICHINCHA_ESPANA_SA,
  BANCO_POPULAR_ESPANOL_SA,
  BANCO_SANTANDER_SA,
  BANCOFAR_SA,
  BANK_DEGROOF_PETERCAM_SPAIN_SA,
  BANKIA_SA,
  BANKINTER_SA,
  BANKOA_SA,
  BMCE_BANK_INTERNATIONAL_SA,
  BNP_PARIBAS_ESPANA_SA,
  CAIXABANK_SA,
  CAJASUR_BANCO_SA,
  CECABANK_SA,
  CITIBANK_ESPANA_SA,
  DEUTSCHE_BANK_SOCIEDAD_ANONIMA_ESPANOLA,
  EBN_BANCO_DE_NEGOCIOS_SA,
  EVO_BANCO_SA,
  IBERCAJA_BANCO_SA,
  KUTXABANK_SA,
  LIBERBANK_SA,
  NUEVO_MICRO_BANK_SA,
  OPEN_BANK_SA,
  POPULAR_BANCA_PRIVADA_SA,
  RENTA_4_BANCO_SA,
  SABADELL_CONSUMER_FINANCE_SA,
  SANTANDER_CONSUMER_FINANCE_SA,
  SANTANDER_INVESTMENT_SA,
  SANTANDER_SECURITIES_SERVICES_SA,
  SELF_TRADE_BANK_SA,
  TARGOBANK_SA,
  UNICAJA_BANCO_SA,
  WIZINK_BANK_SA,
  ING_BANK_NV_SUCURSAL_EN_ESPANA,
  TRIODOS_BANK_NV_SE,
  CAJA_RURAL_DE_SALAMANCA_SOCIEDAD_COOPERATIVA_DE_CREDITO,
  CAJA_RURAL_DE_NAVARRA_SCOOP_DE_CREDITO,
  CAIXA_DE_CREDIT_DELS_ENGINYERS_CAJA_DE_CREDITO_DE_LOS_INGENIEROS_SCOOP_DE_CREDITO
}

export enum EnumTypeMethodPayment {
  TRANSFER10DAYSISSUEDATE = 1,
  TRANSFER20DAYSISSUEDATE = 2,
  TRANSFER25DAYSISSUEDATE = 3,
  DOMICILIATION10DAYSISSUEDATE = 4,
  DOMICILIATION20DAYSISSUEDATE = 5,
  DOMICILIATION25DAYSISSUEDATE = 6,
  TRANSFERDAY25 = 7,
  COMPENSATION = 8,
  ATSIGHTDOMICILEDRECEIPT = 9,
  INVIEWTRANSFER = 10,
  DOMICILIATIONDAY15 = 11,
  DOMICILIATIONDAY30 = 12,
  B2BDAY15 = 13,
  B2BDAY30 = 14,
  TRANSFER45DAYSISSUEDATE = 1001,
  DOMICILIATION30DAYSISSUEDATE = 1002,
  DOMICILIATION7DAYSISSUEDATE = 1003
}

export interface CupsModel {
  id: number
  codCUPS: string
  description: string
  initDate: Date
  endDate: Date
  telemetered: boolean
  automaticMeasurer: boolean
  dischargedDate: Date

  directionInstallation: FiscalAddress
  logisticElement: LogisticElement
  position: LogisticElement
  measurers: Measurer[]
  capacities: Capacity[]
  distributor: Subject
}

export enum EnumLockCapacity {
  LockedBundle = 1,
  LockedUser,
  Free
}

export enum EnumTollType {
  Toll_1_1 = 1,
  Toll_1_2,
  Toll_1_3,
  Toll_2_1,
  Toll_2_2,
  Toll_2_3,
  Toll_2_4,
  Toll_2_5,
  Toll_2_6,
  Toll_3_1,
  Toll_3_2,
  Toll_3_3,
  Toll_3_4,
  Toll_3_5,
  Toll_41,
  Toll_42,
  Toll_43,
  Toll_44,
  Toll_45,
  Toll_46,
  Toll_47,
  Toll_A1,
  Toll_A2,
  Toll_A3,
  Toll_B1,
  Toll_B2,
  Toll_C1,
  Toll_C2,
  Toll_D1,
  Toll_D2,
  Toll_M1,
  Toll_M2,
  Toll_99,
  Toll_BPgt1,
  Toll_BPgt2,
  Toll_BPC1,
  Toll_BPC2,
  Toll_BPL1,
  Toll_BPL2,
  Toll_MP1,
  Toll_MP2,
  Toll_MPC1,
  Toll_MPC2,
  Toll_MPL1,
  Toll_MPL2,
  Toll_BPFXM,
  Toll_BPFXAM,
  Toll_MPFXM,
  Toll_MPFXAM,
  Toll_BPlt1,
  Toll_BPlt2,
  Toll_BPlt3,
  Toll_BPlt4,
  Toll_20A,
  Toll_20DHA,
  Toll_20DHS,
  Toll_21A,
  Toll_21DHA,
  Toll_21DHS,
  Toll_30A,
  Toll_31A,
  Toll_61A,
  Toll_61B,
  Toll_62,
  Toll_63,
  Toll_64,
  Toll_65,
  Toll_BPS1,
  Toll_BPS2
}

export enum EnumNatureType {
  Firm = 1,
  Interruptible = 2,
  FirmClient = 3,
  InterruptibleCustomerA = 4,
  InterruptibleCustomerB = 5
}

export enum EnumServiceEnum {
  InvalidService = 0,
  Regasification = 1,
  CargoTanker = 2,
  CargoShip = 3,
  InputRT = 4,
  DepartureCI = 5,
  StorageCapacity = 6,
  GroupDistribution1Client = 7,
  BuyAndSell = 8,
  Injection = 9,
  Extraction = 10,
  GroupDistribution2Client = 12,
  GroupDistribution3Client = 13,
  RegasificationTransportation = 15,
  GroupDistribution1Carrier = 16,
  GroupDistribution2Distributor = 17,
  GroupDistribution3Distributor = 18,
  Liquefaction = 30,
  StorageGNL = 31,
  StoragePVB = 32,
  DownloadShip = 33,
  Other = 34,
  Monthly = 35,
  CurtasUtilizaçoes = 36,
  LongasUtilizaçoes = 37,
  FlexivelMonthly = 38,
  FlexivelAnnual = 39,
  MonthlyMP = 40,
  MPCurtasUtilizaçoes = 41,
  MPLongasUtilizaçoes = 42,
  MPFlexivelMonthly = 43,
  MPFlexivelAnnual = 44,
  StorageGN = 45
}

export enum EnumProductCapacityType {
  Intraday = 1,
  Daily,
  Monthly,
  Quarterly,
  Anual,
  Restriction
}

export interface Distribution {
  id: number
  quantity: number
  quantityShipping: number
  quantityTSO: number
  operation: Operation
  productCapacity: Capacity
}

export interface Operation {
  id: number
  operationType: EnumTipoOperacion
  state?: EnumOperationState
  operationState?: EnumOperationState
  operationDate: Date
  quantity?: number
  shippingQuantity?: number
  quantityTSO?: number
  balanceZone: EnumZonaBalance
  price: number
  fee: number
  value: string
  idValueType: EnumValueType
  stateTSO: EnumEstadoOperacionConciliar
  codExternal: string
  remitState: EnumRemitState
  yypeAmountTrip: EnumQuantityType
  lgRemitLngActivity: boolean
  lgRemitLngPlanned: boolean
  logisticElement: LogisticElement
  company: Company
  counterPart: Subject
  distributions: Distribution[]
  position: PositionPrice
}

export enum EnumQuantityType {
  Consumption_Conventional = 1,
  Consumption_Electric,
  Consumption_Telemetered,
  Consumption_Telemetered_Estimated,
  Consumption_No_Telemetered,
  Consumption_No_Telemetered_Estimated,
  Decrease,
  Ajustes,
  Input_RT,
  Emission,
  TotalDeliveries,
  Cisterns,
  Consumption_Other,
  Consumption,
  ConsumptionEstimated,
  QdHired,
  QaEstimated,
  Capacity_Contractual,
  Free,
  Nomination,
  DailyMediumMeasured,
  Rest,
  Permanent,
  Percentage,
  BAD,
  AtmosphericPressure,
  SupplyPressure,
  Temperature,
  FactorConversion,
  FactorK,
  PCS,
  Zeta,
  Density,
  n2,
  CO2,
  H2,
  ReadingFrom,
  ReadingUp,
  Historic,
  PCI,
  Adjustment_AE,
  Adjustment_AS,
  Adjustment_Excesos_Potencia,
  Adjustment_Potencia_Maxima,
  Adjustment_Q1,
  Generation_No_Telemeasure,
  Generation_Telemeasure,
  Reading_From_AE,
  Reading_From_AS,
  Reading_From_Excesos_Pot,
  Reading_From_Potencia_Max,
  Reading_From_Q1,
  Reading_To_AE,
  Reading_To_AS,
  Reading_To_Excesos_Pot,
  Reading_To_Potencia_Max,
  Reading_To_Q1,
  PercentageLosses,
  Reactive_Q1,
  Reactive_Q1_No_Telemetry,
  Reactive_Q1_Telemetry,
  Reactive_Q2_Telemetry,
  Reactive_Q3_Telemetry,
  Reactive_Q4_Telemetry,
  VAsTrafo,
  Excesses_Power,
  Maximos_Power,
  PowerMaxDemanded,
  ModeControlPower,
  IndicativeCurveLoad
}

export enum EnumRemitState {
  Lng_activity = 1,
  Lng_planned,
  Lg_generated_sct1,
  Lg_generated_nsct2
}

export enum EnumValueType {
  Int = 1,
  Decimal,
  Char,
  String,
  DateTime
}

export interface Measurer {
  idMeasurer: number
  codMeasurer: string
  description: string
  um: string
  measurerType: EnumMeasurerType
  correctorType: EnumCorrectorType
  flowType: EnumFlowType
  weight: number
  initDate: Date
  endDate: Date
  rented: boolean
  dischargeDate: Date
  uses: Use[]
  cups: CupsModel
}

export interface Use {
  idUse: number
  useType: EnumUseType
  usePercentage: number
  useState: EnumUseState
  initDate: Date
  endDate: Date
}

export enum EnumPeriodicityType {
  Variable = 1,
  Daily,
  Weekly,
  Biweekly,
  Monthly,
  Bimonthly,
  Quarterly,
  Semiannually,
  Annually
}

export enum EnumCycleBillingType {
  Contracts = 1,
  Trades,
  Flexibility,
  Product
}

export enum EnumOperationType {
  TypeOperationInvalid = 0,
  Regasification = 1,
  CargoTanker = 2,
  CargoShip = 3,
  DownloadShip = 4,
  InputRtPCPR = 5,
  InputRtPCI = 6,
  InputRtPCY = 7,
  OutputRtPCI = 9,
  DemandConventional = 11,
  DemandLLDD = 12,
  DemandOthers = 13,
  Purchase = 17,
  Sale = 18,
  DemandLLDDME = 19,
  GNLSettings = 21,
  Losses = 23,
  BuyAndSell = 24,
  Unbalance = 25,
  E_S_AASS = 26,
  InyExtAASS = 27,
  Liquefaction = 28,
  OutputRT_PCTVB = 29,
  Storage_PVB = 30,
  Storage_TVB = 31,
  Unbalance_TVB = 32,
  Unbalance_AASS = 33,
  DischargeCistern = 34,
  EMS = 41,
  Injection = 42,
  Extraction = 43,
  WinterPlan = 45,
  Input_PCAS = 47,
  Output_PCAS = 48,
  Stocks = 50,
  Stock = 99
}

export enum EnumBillingType {
  Normal = 1,
  Simulacion,
  Regeneracion,
  Refacturacion,
  Conciliacion
}

export enum EnumSubjectType {
  AllSubjects = 0,
  Wholesaler,
  ConsumerDirectMarket,
  Distributor,
  Carrier,
  GTS,
  FinalClient,
  Commercial,
  Operator,
  RRM = 10,
  Manager
}

export enum EnumMeasurerType {
  CO = 1,
  CR = 2,
  UR = 3,
  NA = -1
}

export enum EnumCorrectorType {
  PT = 1,
  PTZ,
  PTRemoteUnit,
  NotApply,
  Energy,
  PTZRemoteUnit
}

export enum EnumFlowType {
  G3 = 1,
  G6,
  G10,
  G25,
  G40,
  G65,
  G100,
  G160,
  G250
}

export enum EnumUseType {
  NaturalGas = 2,
  ElectricalUse,
  ThermalUse,
  GNFuel,
  GNElectricity
}

export enum EnumUseState {
  Provisional = 1,
  Definitive = 2
}

export enum EnumElemLogType {
  TODOS = 0,
  PVB,
  PR,
  AASS,
  PCPR,
  PCDB,
  PCCC,
  PCAS,
  PCI,
  PCY,
  PCTD,
  PCDD,
  PCLD,
  PS,
  PE,
  RT,
  RD,
  PCLD_ME,
  PSAT,
  PITGNL,
  PIAS,
  PCRT,
  Suprappoint,
  Position,
  PO,
  Vessel,
  PF,
  PCPF,
  Infrastructure,
  Point,
  Other
}
